/* HYLOR v2 — homepage behaviour.
   Deliberately small: the design's motion is CSS. This handles only the
   mobile nav toggle and the First Taste List honeypot. */
(function () {
  'use strict';

  /* ---- mobile navigation ---- */
  var toggle = document.querySelector('.site-header .menu-button');
  var nav = document.getElementById('primary-navigation');

  if (toggle && nav) {
    var setOpen = function (open) {
      nav.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    };

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('nav-open'));
    });

    /* Close after tapping a link, and on Escape. */
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('nav-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    /* The nav is inline on desktop — drop the open state when we cross back. */
    var wide = window.matchMedia('(min-width: 921px)');
    var onChange = function (event) { if (event.matches) setOpen(false); };
    if (wide.addEventListener) wide.addEventListener('change', onChange);
    else if (wide.addListener) wide.addListener(onChange);
  }

  /* ---- First Taste List honeypot ----
     The trap field is hidden from people and ignored by Shopify. If a bot
     fills it, drop the submission client-side. */
  var form = document.getElementById('first-taste-form');
  var trap = document.getElementById('first-taste-company');

  if (form && trap) {
    form.addEventListener('submit', function (event) {
      if (trap.value !== '') event.preventDefault();
    });
  }

  /* ---- First Taste CTA scroll ----
     Every "Join the First Taste List" button/link on the page points at
     #first-taste. A plain anchor only scrolls on the click that first sets
     the URL hash — a second link sharing that same hash is a no-op in most
     browsers, since the hash doesn't change, so on a long page it can look
     like the button did nothing. Drive the scroll ourselves on every click
     and land focus in the email field so arriving there is unmistakable. */
  var firstTasteTarget = document.getElementById('first-taste');
  var firstTasteEmail = document.getElementById('first-taste-email');

  if (firstTasteTarget) {
    var goToFirstTaste = function () {
      firstTasteTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (firstTasteEmail) {
        /* The email field can sit below the can lineup within the section
           (stacked on mobile) — a second, centered scroll straight to the
           field itself guarantees it (not just the section heading) ends up
           on screen, wherever the layout puts it. */
        window.setTimeout(function () {
          firstTasteEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstTasteEmail.focus({ preventScroll: true });
        }, 450);
      }
    };

    var firstTasteLinks = document.querySelectorAll('a[href="#first-taste"], a[href="/#first-taste"]');
    for (var k = 0; k < firstTasteLinks.length; k++) {
      firstTasteLinks[k].addEventListener('click', function (event) {
        event.preventDefault();
        goToFirstTaste();
      });
    }

    /* Arriving from another page (e.g. /pages/faq#first-taste) — the browser
       already jumped on load, so just land focus in the field. */
    if (window.location.hash === '#first-taste') {
      window.setTimeout(function () {
        if (firstTasteEmail) {
          firstTasteEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstTasteEmail.focus({ preventScroll: true });
        }
      }, 400);
    }
  }

  /* ---- Can zoom ----
     Click or tap any [data-zoomable] can image to open it full-screen.
     Pinch (touch) or the mouse wheel zooms in from there; dragging pans
     once zoomed. Escape, the backdrop, or the close button dismisses it. */
  var zoomables = document.querySelectorAll('[data-zoomable]');

  if (zoomables.length) {
    var modal = document.createElement('div');
    modal.className = 'can-zoom-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<button type="button" class="can-zoom-close" aria-label="Close">&times;</button>' +
      '<div class="can-zoom-stage"><img class="can-zoom-img" alt=""><p class="can-zoom-hint">Pinch or scroll to zoom &middot; drag to pan</p></div>';
    document.body.appendChild(modal);

    var stage = modal.querySelector('.can-zoom-stage');
    var zoomImg = modal.querySelector('.can-zoom-img');
    var closeBtn = modal.querySelector('.can-zoom-close');
    var lastFocus = null;
    var scale = 1, panX = 0, panY = 0;
    var pointers = {};
    var pinchStartDist = 0, pinchStartScale = 1;
    var dragStart = null;

    var applyTransform = function () {
      zoomImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    };

    var resetZoom = function () {
      scale = 1; panX = 0; panY = 0;
      applyTransform();
    };

    var openZoom = function (src, label) {
      lastFocus = document.activeElement;
      zoomImg.src = src;
      zoomImg.alt = label || '';
      resetZoom();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('can-zoom-lock');
      closeBtn.focus();
    };

    var closeZoom = function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('can-zoom-lock');
      resetZoom();
      zoomImg.src = '';
      pointers = {};
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    for (var i = 0; i < zoomables.length; i++) {
      (function (el) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', function () {
          openZoom(el.currentSrc || el.src, el.alt);
        });
        el.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openZoom(el.currentSrc || el.src, el.alt);
          }
        });
      })(zoomables[i]);
    }

    closeBtn.addEventListener('click', closeZoom);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeZoom();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeZoom();
    });

    /* Double-click / double-tap toggles between 1x and 2.4x. */
    stage.addEventListener('dblclick', function () {
      scale = scale > 1 ? 1 : 2.4;
      panX = 0; panY = 0;
      applyTransform();
    });

    /* Wheel zoom (desktop trackpad/mouse). */
    stage.addEventListener('wheel', function (event) {
      event.preventDefault();
      var delta = -event.deltaY * 0.0025;
      scale = Math.min(4, Math.max(1, scale + delta));
      if (scale === 1) { panX = 0; panY = 0; }
      applyTransform();
    }, { passive: false });

    /* Pointer-based pinch zoom (two active pointers) + drag pan (one, once zoomed). */
    stage.addEventListener('pointerdown', function (event) {
      stage.setPointerCapture(event.pointerId);
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStartDist = Math.hypot(b.x - a.x, b.y - a.y);
        pinchStartScale = scale;
      } else if (ids.length === 1 && scale > 1) {
        dragStart = { x: event.clientX - panX, y: event.clientY - panY };
      }
    });

    stage.addEventListener('pointermove', function (event) {
      if (!pointers[event.pointerId]) return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(b.x - a.x, b.y - a.y);
        if (pinchStartDist > 0) {
          scale = Math.min(4, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
          applyTransform();
        }
      } else if (ids.length === 1 && dragStart) {
        panX = event.clientX - dragStart.x;
        panY = event.clientY - dragStart.y;
        applyTransform();
      }
    });

    var endPointer = function (event) {
      delete pointers[event.pointerId];
      if (Object.keys(pointers).length < 2) pinchStartDist = 0;
      dragStart = null;
      if (scale <= 1) resetZoom();
    };
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
    stage.addEventListener('pointerleave', endPointer);
  }

  /* ---- The Fountain: hub filter + search ----
     Scoped per .series-section so a future second topic group (its own
     filters/search/grid) behaves independently rather than sharing state. */
  var fountainSections = document.querySelectorAll('.fountain-hub .series-section');
  fountainSections.forEach(function (section) {
    var search = section.querySelector('.fountain-search');
    var buttons = [].slice.call(section.querySelectorAll('[data-filter]'));
    var cards = [].slice.call(section.querySelectorAll('.series-grid .article-card'));
    var countEl = section.querySelector('.fountain-results-count');
    var noResults = section.querySelector('.no-results');
    if (!cards.length) return;

    var filter = 'all';
    var update = function () {
      var query = (search ? search.value : '').toLocaleLowerCase().trim();
      var count = 0;
      cards.forEach(function (card) {
        var matches = (filter === 'all' || card.dataset.group === filter) && card.dataset.search.indexOf(query) !== -1;
        card.hidden = !matches;
        if (matches) count++;
      });
      if (countEl) countEl.textContent = count + (count === 1 ? ' article' : ' articles') + ' · in reading order';
      if (noResults) noResults.hidden = count > 0;
    };

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        filter = button.dataset.filter;
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        update();
      });
    });
    if (search) search.addEventListener('input', update);
  });

  /* ---- The Fountain: collapse the sidebar accordions on mobile ---- */
  var fountainAccordions = document.querySelectorAll('.fountain-article-page .reading-sidebar details[open]');
  if (fountainAccordions.length && window.matchMedia('(max-width: 560px)').matches) {
    fountainAccordions.forEach(function (details) { details.open = false; });
  }

  /* ---- The Fountain: build "In this article" from the article's own headings ----
     Done client-side because article.content is rich text — Liquid has no
     way to pull h2[id]/text pairs out of it, and this stays correct even
     after the body is edited later in the admin. */
  var toc = document.querySelector('.fountain-toc nav');
  if (toc) {
    var headings = document.querySelectorAll('.fountain-article-page .article-body h2[id]');
    if (headings.length) {
      headings.forEach(function (heading) {
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        toc.appendChild(link);
      });
      var referencesHeading = document.querySelector('.fountain-article-page .references');
      if (referencesHeading) {
        var refLink = document.createElement('a');
        refLink.href = '#references';
        refLink.textContent = 'References';
        toc.appendChild(refLink);
      }
    } else {
      var tocDetails = document.querySelector('.fountain-toc');
      if (tocDetails) tocDetails.hidden = true;
    }
  }

  /* ---- The Fountain: "View full-size figure" link on each embedded figure ----
     Figures live in article.content (rich text), so this is added client-side
     rather than templated. Links straight to the original image, new tab. */
  document.querySelectorAll('.fountain-article-page .article-figure img').forEach(function (img) {
    var figure = img.closest('figure');
    if (!figure || figure.querySelector('.fountain-figure-link')) return;
    var link = document.createElement('a');
    link.className = 'fountain-figure-link';
    link.href = img.currentSrc || img.src;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'View full-size figure';
    figure.appendChild(link);
  });

  /* ---- The Fountain: copy link + native share ---- */
  var copyButton = document.querySelector('.fountain-copy-link');
  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var url = copyButton.dataset.url;
      var done = function () {
        var label = copyButton.querySelector('.fountain-copy-link-label');
        var original = label.textContent;
        copyButton.setAttribute('data-copied', 'true');
        label.textContent = 'Copied!';
        setTimeout(function () {
          copyButton.removeAttribute('data-copied');
          label.textContent = original;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(input);
      }
    });
  }

  var shareButton = document.querySelector('.fountain-native-share');
  if (shareButton) {
    if (navigator.share) {
      shareButton.hidden = false;
      shareButton.addEventListener('click', function () {
        navigator.share({ title: shareButton.dataset.title, url: shareButton.dataset.url }).catch(function () {});
      });
    }
  }
})();
